import React, { useEffect, useLayoutEffect, useState } from "react";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import AsyncSelect from "react-select/async";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import {
  addDoc,
  and,
  collection,
  doc,
  getDoc,
  getDocs,
  or,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import Dateformat from "helper/constant/timeFormat";
import ErrorMessages from "helper/errorMessages";
import { dbFirestore } from "helper/config/firebase";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";


function AddMockTestInfo() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [studentsID, setStudentsID] = useState();
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [mockTestHeading, setMockTestHeading] = useState(
    CommonHeadings.mockTestAddHeading
  );
  const [testDate, setTestDate] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [mockData, setMockData] = useState({
    // set input values
    student_firebase_id: null,
    student_type: null,
    admission_number: "",
    student_name: null,
    test_date: null,
    test_date_timestamp: null,
    speaking_marks: "",
    writing_marks: "",
    listening_marks: "",
    reading_marks: "",
    overall_marks: "",
  });

  const [errors, setErrors] = useState({
    student_firebase_id: "",
    student_type: "",
    admission_number: "",
    student_name: "",
    test_date: "",
    speaking_marks: "",
    writing_marks: "",
    listening_marks: "",
    reading_marks: "",
    overall_marks: "",
  });

  // MARK: use effect method
  useEffect(() => {
    if (location.state) {
      setEditMockTestUI();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // use layout method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.mockTestEditHeading
      : CommonHeadings.mockTestAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //   when we enter any value that's set in the setDemoStudents() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    var { name, value } = e.target;

    if (name === "test_date") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    setMockData({
      ...mockData,
      [name]: value,
    });
  };

  const studentsTypeSelect = (e) => {
    const name = "student_type";

    setMockData({
      ...mockData,
      [name]: e,
    });
  };

  const studentsSelect = (e) => {
    const name = "student_firebase_id";

    setMockData({
      ...mockData,
      [name]: e,
    });

    if (e === null) {
      return;
    }
    setMockData((prevState) => ({
      ...prevState,
      student_name: e.name,
      admission_number: e.admission_no
    }));
  };

  const validateForm = (data) => {
    const errors = {};
    if (!data.student_type) {
      errors.student_type = ErrorMessages.studentType;
    }
    if (!data.admission_number) {
      errors.admission_number = ErrorMessages.admissionNumber;
    }
    if (!data.student_name) {
      errors.student_name = ErrorMessages.studentName;
    }
    if (!data.test_date) {
      errors.test_date = ErrorMessages.testDate;
    }
    if (!data.speaking_marks) {
      errors.speaking_marks = ErrorMessages.speakingMarks;
    }
    if (!data.writing_marks) {
      errors.writing_marks = ErrorMessages.writingMarks;
    }
    if (!data.listening_marks) {
      errors.listening_marks = ErrorMessages.listeningMarks;
    }
    if (!data.reading_marks) {
      errors.reading_marks = ErrorMessages.readingMarks;
    }
    if (!data.overall_marks) {
      errors.overall_marks = ErrorMessages.overallMarks;
    }
    if (data.student_type === "existing_student") {
      if (!data.student_firebase_id) {
        errors.student_firebase_id = ErrorMessages.studentId;
      }
    }

    return errors;
  };

  // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(mockData);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateMockTestApi();
      } else {
        writeMockTestApi();
      }
    }
  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(mockData);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeMockTestApi(true);
    }
  };

  // MARK: string to date
  const stringToDate = (props) => {
    return moment(props, Dateformat.YYYYMMDD).toDate();
  };

  // MARK: edit data function
  async function setEditMockTestUI() {
    const studentTypeObject = await fetchStudentTypeApi();

    const testDate = stringToDate(location.state.test_date);
    setTestDate(testDate);

    var regularStudentObject;
    if (studentTypeObject.type === "existing_student") {
      regularStudentObject = await fetchRegularStudentApi();
    } else {
      regularStudentObject = null;
    }

    setMockData((prevState) => ({
      ...prevState,
      student_type: studentTypeObject,
      student_firebase_id: regularStudentObject,
      student_name: location.state.student_name,
      admission_number: location.state.admission_number,
      test_date: location.state.test_date,
      speaking_marks: location.state.speaking_marks,
      writing_marks: location.state.writing_marks,
      listening_marks: location.state.listening_marks,
      reading_marks: location.state.reading_marks,
      overall_marks: location.state.overall_marks,
    }));
    setMockTestHeading(CommonHeadings.mockTestEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setStudentsID(location.state.id);
  }

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();

    const object = {
      ...mockData,
      created_at: createdAt,
      updated_at: null,
    };

    const dateOnly = Timestamp.fromDate(new Date(object.test_date)).toMillis();
    object.test_date_timestamp = dateOnly;
    object.student_name = mockData.student_name.toLowerCase();

    return object;
  }

  // MARK: reset values function
  function ResetValues() {
    setMockData({
      student_firebase_id: "",
      student_type: "",
      student_name: "",
      admission_number: "",
      test_date: "",
      test_date_timestamp: "",
      speaking_marks: "",
      writing_marks: "",
      listening_marks: "",
      reading_marks: "",
      overall_marks: "",
    });
  }

  // MARK: API
  //  regular student API
  async function fetchRegularStudentApi() {
    const docRef = doc(dbFirestore, TableName.students, location.state.student_firebase_id)
    const docSnap = await getDoc(docRef);
    
    return docSnap.exists() ? docSnap.data() : null;
  }

  // student type API
  async function fetchStudentTypeApi() {
    let q = query(collection(dbFirestore, TableName.studentsType));

    const querySnapshot = await getDocs(q);

    const studentTypeArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    var typeObject = studentTypeArray.find(function (studentType) {
      return studentType.type === location.state.student_type;
    });

    return typeObject;
  }

  // write API
  async function writeMockTestApi(edit) {
    const writePayload = payload();
    writePayload.student_type = mockData.student_type.type;
    if (mockData.student_firebase_id) {
      writePayload.student_firebase_id =
        mockData.student_firebase_id.firebase_id;
    }

    try {
      await addDoc(collection(dbFirestore, TableName.mockTest), {
        ...writePayload,
      });

      if (edit) {
        toast.success(ToastMessages.performanceAdd);
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addMockTextInfo);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.performanceAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.mockTestList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  //  update API
  async function updateMockTestApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    updatedPayload.student_type = mockData.student_type.type;
    if (mockData.student_firebase_id) {
      updatedPayload.student_firebase_id =
        location.state.student_firebase_id;
    }
    try {
      await updateDoc(doc(dbFirestore, TableName.mockTest, studentsID), {
        ...updatedPayload,
      });
      toast.success(ToastMessages.performanceUpdated);

      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.mockTestList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: students list fetch from the firebase
  const regularStudentsList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.students),and(
        where('status', '==', 'active'),   
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    ));
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    return s;
  };


  // MARK: students name which show in the dropdown
  function studentsName(e) {
    return e["name"] + " - " + e["admission_no"];
  }

  // MARK: students list fetch from the firebase
  const studentsTypeList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.studentsType),
      or(
        // query as-is:
        and(
          where("type", ">=", searchName),
          where("type", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "type",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "type",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    return s;
  };

  //  students name which show in the dropdown
  function studentsType(e) {
    return e["type"];
  }

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-4" headingName={mockTestHeading} />

          <div className="p-fluid">
            <div className="row modules__row">
              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="student_type" className="input__valid">Student Type</label>
                <AsyncSelect
                  classNamePrefix="batch__dropdown"
                  isClearable
                  cacheOptions
                  loadOptions={studentsTypeList}
                  value={mockData.student_type}
                  defaultOptions
                  getOptionLabel={(e) => studentsType(e)}
                  getOptionValue={(e) => e}
                  onChange={studentsTypeSelect}
                />
                {isSubmitted && (
                  <small id="student_type" className="p-error">
                    {errors.student_type}{" "}
                  </small>
                )}
              </div>

              {mockData.student_type?.type === "existing_student" && <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="student_firebase_id" className="input__valid">Select Student</label>
                <AsyncSelect
                  isClearable
                  cacheOptions
                  loadOptions={regularStudentsList}
                  value={mockData.student_firebase_id}
                  defaultOptions
                  getOptionLabel={(e) => studentsName(e)}
                  getOptionValue={(e) => e}
                  onChange={studentsSelect}
                />

                {isSubmitted && (
                  <small id="student_firebase_id" className="p-error">
                    {errors.student_firebase_id}{" "}
                  </small>
                )}
              </div>}

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="student_name" className="input__valid">Student Name</label>
                <InputText
                  name="student_name"
                  value={mockData.student_name}
                  onChange={inputChange}
                  id="student_name"
                  type="text"
                  placeholder="Enter student name"
                />
                {isSubmitted && (
                  <small id="student_name" className="p-error">
                    {errors.student_name}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="admission_number" className="input__valid">Admission Number</label>
                <InputText
                  name="admission_number"
                  value={mockData.admission_number}
                  onChange={inputChange}
                  id="admission_number"
                  type="text"
                  placeholder="Enter admission number"
                />
                {isSubmitted && (
                  <small id="admission_number" className="p-error">
                    {errors.admission_number}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="test_date" className="input__valid">Test Date</label>
                <Calendar
                  value={testDate}
                  name="test_date"
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
                {isSubmitted && (
                  <small id="test_date" className="p-error">
                    {errors.test_date}{" "}
                  </small>
                )}
              </div>
            </div>

            <div className="row modules__row">
              <HeadingComponent
                classname="mb-2 mt-3"
                headingName="Marks Detail"
              />

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="speaking_marks" className="input__valid">Speaking</label>
                <InputText
                  name="speaking_marks"
                  value={mockData.speaking_marks}
                  onChange={inputChange}
                  id="speaking_marks"
                  type="text"
                  placeholder="Enter marks"
                />
                {isSubmitted && (
                  <small id="speaking_marks" className="p-error">
                    {errors.speaking_marks}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="writing_marks" className="input__valid">Writing</label>
                <InputText
                  name="writing_marks"
                  value={mockData.writing_marks}
                  onChange={inputChange}
                  id="writing_marks"
                  type="text"
                  placeholder="Enter marks"
                />
                {isSubmitted && (
                  <small id="writing_marks" className="p-error">
                    {errors.writing_marks}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="listening_marks" className="input__valid">Listening</label>
                <InputText
                  name="listening_marks"
                  value={mockData.listening_marks}
                  onChange={inputChange}
                  id="listening_marks"
                  type="text"
                  placeholder="Enter marks"
                />
                {isSubmitted && (
                  <small id="listening_marks" className="p-error">
                    {errors.listening_marks}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="reading_marks" className="input__valid">Reading</label>
                <InputText
                  name="reading_marks"
                  value={mockData.reading_marks}
                  onChange={inputChange}
                  id="reading_marks"
                  type="text"
                  placeholder="Enter marks"
                />
                {isSubmitted && (
                  <small id="reading_marks" className="p-error">
                    {errors.reading_marks}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <label htmlFor="overall_marks" className="input__valid">Overall Marks</label>
                <InputText
                  name="overall_marks"
                  value={mockData.overall_marks}
                  onChange={inputChange}
                  id="overall_marks"
                  type="text"
                  placeholder="Enter overall marks"
                />
                {isSubmitted && (
                  <small id="overall_marks" className="p-error">
                    {errors.overall_marks}{" "}
                  </small>
                )}
              </div>
            </div>
          </div>

          <BottomButtons
            label={buttonLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddMockTestInfo;
